module.exports = __webpack_public_path__ + "static/img/7f.fb2a86c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/7f.jpg
// module id = 1DA7
// module chunks = 0